(function () {
    "use strict";

    angular
        .module("app")
        .directive('hierarchyDirective', hierarchyDirective)
        .directive('hierarchyScroll', hierarchyScroll)
        .directive('hierarchyMoveToBottom', hierarchyMoveToBottom);

    function hierarchyDirective($rootScope, $state, $filter, $timeout, ImageUrl, UserPreferenceService, LinePlanService, BriefService, PatternService, PrototypeService, DefaultEnlargeSize) {
        return {
            restrict: 'E',
            link: function (scope, ele) {
                ele[0].className = "ibox-content customtable"; //assign class here so its less work in the front end

                angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
                    //lineplan
                    if (userPermissionRow[0] == 1) {
                        if (userPermissionRow[1] == 1) {
                            scope.LinePlanRead = true;
                        }
                        if (userPermissionRow[1] == 2) {
                            scope.LinePlanEdit = true;
                        }
                    }

                    //brief
                    if (userPermissionRow[0] == 3) {
                        if (userPermissionRow[1] == 1) {
                            scope.BriefRead = true;
                        }
                        if (userPermissionRow[1] == 2) {
                            scope.BriefEdit = true;
                        }
                    }

                    //pattern
                    if (userPermissionRow[0] == 4) {
                        if (userPermissionRow[1] == 1) {
                            scope.PatternRead = true;
                        }
                        if (userPermissionRow[1] == 2) {
                            scope.PatternEdit = true;
                        }
                    }

                    //colorway
                    if (userPermissionRow[0] == 5) {
                        if (userPermissionRow[1] == 1) {
                            scope.ColorwayRead = true;
                        }
                        if (userPermissionRow[1] == 2) {
                            scope.ColorwayEdit = true;
                        }
                    }
                });
                
                switch (scope.project) {
                    case 1:
                        scope.projectName = 'linePlan';
                        break;
                    case 2:
                        scope.projectName = 'brief';
                        break;
                    case 3:
                        scope.projectName = 'pattern';
                        break;
                    case 4:
                        scope.projectName = 'colorway';
                        break;
                }
                
                scope.isFactoryUser = scope.$root.currentUser.isFactoryUser;

                UserPreferenceService.getUserPreferences('Hierarchy').then(function (response) {
                    var data = response[0];
                    if (data) {
                        var preference = eval('(' + data.PreferenceValue + ')')
                        scope.hierarchyViews = preference;
                        scope.userPreferenceId = data.UserPreferenceId;
                    } else {
                        scope.hierarchyViews = {
                            linePlan: [1, 1, 1, 1],
                            brief: [1, 1, 1, 1],
                            pattern: [1, 1, 1, 1],
                            colorway: [1, 1, 1, 1]
                        };
                    }

                });

                scope.$watch('linePlanId', function (n, o) {
                    if (n) {
                        getLinePlan(n);
                    }
                });

                scope.$watch('briefId', function (n, o) {
                    if (n) {
                        getBriefs(n);
                    }
                });

                scope.$watch('patternId', function (n, o) {
                    if (n) {
                        getPatterns(n);
                    }
                });

                scope.$watch('colorwayId', function (n, o) {
                    if (n) {
                        getColorways(n);
                    }
                });

                scope.$watch("updateDirectives", function (newValue) {
                    if (typeof newValue === "undefined")
                        return;
                    if (scope.linePlanId)
                        getLinePlan(scope.linePlanId);
                    if (scope.briefId)
                        getBriefs(scope.briefId);
                    if (scope.patternId)
                        getPatterns(scope.patternId);
                    if (scope.colorwayId)
                        getColorways(scope.colorwayId);

                });

                function getLinePlan(id) {
                    scope.linePlan = true;
                    //if brief
                    if (!id)
                        return;
                    BriefService.getBriefLinePlans(id).then(function (data) {
                        scope.linePlanList = data;
                        var lpid = data[0] ? data[0].LinePlanId : null;

                        if (scope.project === 2)
                            getBriefs(lpid);
                    });

                }

                function getBriefs(id) {
                    scope.briefs = true;
                    if (!id)
                        return;
                    if (scope.project === 1 || scope.project === 2) {
                        //Get Lineplan briefs
                        LinePlanService.getLinePlanBriefs(id).then(function (data) {
                            scope.briefList = $filter('filter')(data, { BriefSeasonalId: '!' + scope.patternId }); //patternId is actually brief seasonal id
                            scope.getImages(data, 'BriefSeasonalId', 2);
                        });
                    }

                    if (scope.project === 3) {
                        //Get Pattern Brief
                        PatternService.getPatternBriefs(id).then(function (data) {
                            scope.briefList = data;
                            scope.getImages(data, 'BriefSeasonalId', 2);
                            var bid = data[0] ? data[0].BriefSeasonalId : null;

                            getLinePlan(bid);
                            getPatterns(bid);
                            scope.$parent.$parent.$parent.vm.patternBriefs = data;
                        });
                    }

                    if (scope.project === 4) {
                        //Get Prototype Brief
                        PrototypeService.getPrototypeBrief(id).then(function (data) {
                            scope.briefList = [data];
                            scope.getImages([data], 'BriefSeasonalId', 2);
                        });
                    }
                }

                function getPatterns(id) {
                    scope.patterns = true;
                    if (!id)
                        return;
                    if (scope.project === 2 || scope.project === 3) {
                        //Get Brief/Pattern Patterns/Siblings
                        BriefService.getBriefPatternsFactoryFiltered(id).then(function (data) {
                            scope.getImages(data, 'PatternId', 3);
                            var filteredData = $filter('filter')(data, { PatternSeasonalId: '!' + scope.briefId });
                            scope.patternList = filteredData; //briefId is actually pattern seasonal id
                        });
                    }

                    //Get Prototype Patterns
                    if (scope.project === 4) {
                        PrototypeService.getPrototypePatterns(id).then(function (data) {
                            scope.getImages(data, 'PatternId', 3);
                            scope.patternList = data;
                        });
                    }
                }

                function getColorways(id) {
                    scope.colorways = true;
                    if (!id)
                        return;
                    //Get Pattern Prototypes SIBLINGS
                    PatternService.getPatternPrototypes(id).then(function (data) {
                        scope.getImages(data, 'PrototypeId', 4);
                        var filteredData = $filter('filter')(data, { PrototypeSeasonalId: '!' + scope.briefId });
                        scope.colorwayList = filteredData; //briefId is actually prototype seasonal id
                        scope.$parent.$parent.$parent.vm.patternPrototypes = filteredData;
                    });
                }

                var loadingSuccessTimeout, loadingTimeout;
                scope.changeView = function (projectName, level, value) {
                    scope.loading = level+1;
                    scope.hierarchyViews[projectName][level] = value;
                    scope.loadingSuccess = false;
                    $timeout.cancel(loadingTimeout);
                    $timeout.cancel(loadingSuccessTimeout);

                    var userPreferenceModel = {
                        UserPreferenceId: scope.userPreferenceId,
                        PreferenceName: "Hierarchy",
                        model: angular.toJson(scope.hierarchyViews)
                    }

                    UserPreferenceService.updateUserPreferences(userPreferenceModel).then(function (data) {
                        if (!scope.userPreferenceId)
                            scope.userPreferenceId = data;

                        //smooth save and confirm loader
                        loadingTimeout = $timeout(function () {
                            scope.loadingSuccess = true;
                            loadingSuccessTimeout = $timeout(function () {
                                scope.loading = "";
                                scope.loadingSuccess = false;
                            }, 2500);
                        }, 200);
                    });
                }

                function getImageString(projectId, projectLevel, imageType, type) {
                    var date = new Date();
                    switch (type) {
                        case 1:
                            return ImageUrl
                                + "?projectId=" + projectId
                                + "&projectLevel=" + projectLevel
                                + "&imageType=" + imageType
                                + "&size=" + 65 + '&t=' + $filter('date')(date, 'MMddyyHHmmss');
                        case 2:
                            return ImageUrl
                                + "?projectId=" + projectId
                                + "&projectLevel=" + projectLevel
                                + "&imageType=" + imageType
                                + "&size=" + 105 + '&t=' + $filter('date')(date, 'MMddyyHHmmss');
                        case 3:
                            return ImageUrl
                                + "?projectId=" + projectId
                                + "&projectLevel=" + projectLevel
                                + "&imageType=" + imageType
                                + "&size=" + DefaultEnlargeSize + '&t=' + $filter('date')(date, 'MMddyyHHmmss');
                    }
                }

                scope.applyToAllProjects = function (project, value) {
                    angular.forEach(scope.hierarchyViews, function (k, v) {
                        k[project] = value;
                    });

                    scope.changeView(project+1);
                }
                
                scope.getImages = function (data, imageProjectId, projectLevel) {
                    angular.forEach(data, function (k, v) {
                        var projectId = k[imageProjectId];
                        k.Images = [];
                        k.Images.push({ Image: getImageString(projectId, projectLevel, 1, 1), Image2: getImageString(projectId,projectLevel, 1, 2), ImageFull: getImageString(projectId, projectLevel, 1, 3) });
                        if (projectLevel === 3)
                            k.Images.push({ Image: getImageString(projectId, projectLevel, 2, 1), Image2: getImageString(projectId, projectLevel, 2, 2), ImageFull: getImageString(projectId, projectLevel, 2, 3) });
                    });
                }

                //default sort order set to false (desc) so when you first click, its asc
                scope.tableSortDir1 = ''; //brief
                scope.tableSortDir2 = ''; //pattern
                scope.tableSortDir3 = ''; //colorway
                scope.tableSort = function (n, h) {
                    if (h !== scope['tableSortName'+n]) {
                        //reset order direction if new name is chosen
                        scope['tableSortDir'+n] = '';
                    }

                    scope['tableSortName' + n] = h;

                    if (scope['tableSortDir' + n] === '') { //first click
                        scope['tableSortDir' + n] = false
                        scope['tableSortClass'+ n] = 'fa-caret-up';
                    } else if (scope['tableSortDir' + n] === false) { //second click
                        scope['tableSortDir' + n] = true
                        scope['tableSortClass' + n] = 'fa-caret-down';
                    } else { //third click, reset it all
                        scope['tableSortDir' + n] = '';
                        scope['tableSortClass' + n] = '';
                        scope['tableSortName' + n] = '';
                    }
                }

                var parentForm = scope.$parent.form;

                scope.formHandlerDown = function () {
                    if (!parentForm.$dirty)
                        scope.changeFormPristine = true;
                }
                scope.formHandlerUp = function () {
                    if (scope.changeFormPristine)
                        parentForm.$setPristine();
                }
            },
            scope: { linePlanId: "=", briefId: "=", patternId: "=", colorwayId: "=", project: "=?", updateDirectives: "=" },
            templateUrl: templateUrl('app/directives/hierarchy/hierarchy.directive.html')
        }
    }
    function hierarchyScroll() {
        return {
            restrict: 'A',
            link: function (scope, ele) {
                var fade = document.createElement('div');
                fade.className = 'plm-grid-scroll-overlay';
                fade.innerHTML = '<div><span>Click to Expand</span></div>';

                scope.$watch('hierarchyScroll', function (n, o) {
                    if (n !== o && n > 6 && scope.project) {
                        ele[0].appendChild(fade);
                        angular.element(ele[0]).addClass('plm-grid-scroll');
                    }
                });

                fade.addEventListener('click', function () {
                    if (fade.className.indexOf('bottom') === -1) {
                        angular.element(fade).addClass('bottom');
                        angular.element(ele[0]).removeClass('plm-grid-scroll');
                        fade.innerHTML = '<div><span>Click to Minimize</span></div>';
                    } else {
                        angular.element(fade).removeClass('bottom');
                        angular.element(ele[0]).addClass('plm-grid-scroll');
                        fade.innerHTML = '<div><span>Click to Expand</span></div>';
                    }
                    
                });
            },
            scope: { hierarchyScroll: "=", project: "="}
        }
    }

    function hierarchyMoveToBottom() {
        return {
            restrict: 'A',
            link: function (scope, ele) {
                var child = ele[0];
                var parent = ele[0].parentElement;

                if (scope.hierarchyMoveToBottom) {
                    parent.removeChild(child);
                    parent.appendChild(child);
                }
            },
            scope: { hierarchyMoveToBottom: "=" }
        }
    }
})();
